import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Manifesto from "./components/Manifesto";
import Pricing from "./components/Pricing";
import Coverage from "./components/Coverage";
import RegisterSection from "./components/RegisterSection";
import Footer from "./components/Footer";
import ServicePage from "./pages/ServicePage";
import MitraPage from "./pages/MitraPage";
import { ADMIN_URL } from "./lib/site";

function Home() {
  const [pkg, setPkg] = useState("fasnet-20");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#050914] font-sans text-slate-100 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Pricing selected={pkg} onSelect={setPkg} />
        <Coverage />
        <RegisterSection selected={pkg} onSelect={setPkg} />
      </main>
      <Footer />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

function AdminRedirect() {
  useEffect(() => {
    window.location.replace(ADMIN_URL);
  }, []);
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050914]">
      <p data-testid="admin-redirect-text" className="font-mono text-sm text-slate-400">
        Mengalihkan ke Dashboard Admin Fasnet...
      </p>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/layanan" element={<ServicePage />} />
        <Route path="/mitra" element={<MitraPage />} />
        <Route path="/admin" element={<AdminRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}
